import { render } from "./Jamakkol.vue?vue&type=template&id=61bc767e&scoped=true"
import script from "./Jamakkol.vue?vue&type=script&lang=js"
export * from "./Jamakkol.vue?vue&type=script&lang=js"

import "./Jamakkol.vue?vue&type=style&index=0&id=61bc767e&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61bc767e"]])

export default __exports__